var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconWau = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "currentColor"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-wau_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m15.514 3.83.772 1.689h-1.545zm2.095 4.583L17.2 7.52h-3.373l-.41.894a1 1 0 0 1-1.818-.831l2.641-5.777c.499-1.09 2.048-1.09 2.547 0l2.641 5.777a1 1 0 1 1-1.819.831m-9.647-7.41a1 1 0 0 1 .817 1.153L7.774 8.055C7.587 9.15 6.08 9.31 5.668 8.278l-1.027-2.57L3.6 8.284c-.416 1.028-1.92.865-2.105-.228l-.999-5.9a1 1 0 1 1 1.972-.335l.469 2.767.69-1.706c.37-.92 1.673-.917 2.04.004l.673 1.682.468-2.748a1 1 0 0 1 1.154-.818M6.536 12.06a1 1 0 1 1 2 0v6.983h-2zM4.51 13.2a1 1 0 0 0-1 1v4.843h2V14.2a1 1 0 0 0-1-1m-3.028 2.79a1 1 0 0 0-1 1v2.053h2V16.99a1 1 0 0 0-1-1m12.404-3.923a1 1 0 0 0-2 0v3.414a3.629 3.629 0 1 0 7.257 0v-3.414a1 1 0 0 0-2 0v3.414a1.629 1.629 0 0 1-3.257 0z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-wau_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgIconWau;